// Thai has no spaces between words, so browsers pick line breaks with ICU's Thai dictionary — which
// doesn't know common loanwords and splits them mid-word: "แอดมินของ" → แอด|มิ|นข|อง, "แชทออเดอร์" →
// แช|ทอ|อเด|อร์, "แรงค์" → แรง|ค์, "แท็บนี้" → แท็|บนี้. On a phone that shows up as a word chopped across
// two lines ("ตัวหนังสือตก").
//
// keepThaiWords() glues each listed word with U+2060 WORD JOINER (zero-width, invisible, no line break
// allowed on either side) between its character clusters, so a line can only break before or after the
// whole word. Joiners never go in front of a combining vowel/tone mark, so shaping is unaffected.
// Display-only: don't feed the result back into inputs, comparisons or Firestore.
const WJ = '⁠';

// Words verified (Intl.Segmenter 'th', ICU 78) to be split mid-word in jobboard copy and job posts.
const WORDS = [
    'ซุปเปอร์แอดมิน', 'แอดมิน', 'แชท', 'ออเดอร์', 'แรงค์', 'แท็บ', 'ไอดี', 'ดันเจี้ยน', 'กิลด์',
];

// A Thai combining mark (above/below vowels, tone marks, thanthakhat …) or sara am stays attached to
// the character before it.
const ATTACHED = /[ัำ-ฺ็-๎]/;

const glue = (word) => Array.from(word).reduce(
    (out, ch, i) => out + (i > 0 && !ATTACHED.test(ch) ? WJ : '') + ch, '');

const GLUED = new Map(WORDS.map((w) => [w, glue(w)]));
// Longest first so 'ซุปเปอร์แอดมิน' wins over 'แอดมิน'.
const PATTERN = new RegExp([...WORDS].sort((a, b) => b.length - a.length).join('|'), 'g');

export function keepThaiWords(text) {
    if (typeof text !== 'string' || !text) return text;
    return text.replace(PATTERN, (w) => GLUED.get(w));
}
